import React, { useState, useEffect } from 'react'
import { useProgress } from '@react-three/drei'
import { useConfigurator } from './ConfiguratorContext'

const CATEGORIES = [
    { key: 'body', label: 'BODY' },
    { key: 'wheels', label: 'WHEELS' },
    { key: 'interior', label: 'INTERIOR' },
]

const CONTROLS = {
    body: [
        { key: 'colorBody', label: 'Body Paint', type: 'color' },
        { key: 'bodymaterialType', label: 'Metal \u2190\u2192 Matt', type: 'range', min: 0, max: 1, step: 0.01 },
        { key: 'colorCarbon', label: 'Carbon Color', type: 'color' },
    ],
    wheels: [
        { key: 'Rims', label: 'Rims', type: 'color' },
        { key: 'rimsmaterialType', label: 'Metal \u2190\u2192 Matt', type: 'range', min: 0, max: 1, step: 0.01 },
        { key: 'Caliper', label: 'Caliper Color', type: 'color' },
        { key: 'calipermaterialType', label: 'Metal \u2190\u2192 Matt', type: 'range', min: 0, max: 1, step: 0.01 },
        { key: 'rimCovers', label: 'Center Wheel', type: 'color' },
        { key: 'Springs', label: 'Springs', type: 'color' },
    ],
    interior: [
        { key: 'seatMainMaterial', label: 'Seat Main', type: 'color' },
        { key: 'seatSecondaryMaterial', label: 'Seat Secondary', type: 'color' },
        { key: 'roofMaterial', label: 'Roof', type: 'color' },
        { key: 'wheelMaterial', label: 'Steering Wheel', type: 'color' },
        { key: 'stitchMaterial', label: 'Stitching', type: 'color' },
    ],
}

export default function ConfiguratorUI() {
    const { config, updateConfig, activeCategory, toggleCategory } = useConfigurator()
    const controls = activeCategory ? CONTROLS[activeCategory] : null
    const { progress } = useProgress()
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        if (progress === 100) {
            const timer = setTimeout(() => setVisible(true), 1200)
            return () => clearTimeout(timer)
        }
    }, [progress])

    return (
        <div className={`configurator-overlay ${visible ? 'configurator-overlay--visible' : ''}`}>
            {/* Side panel */}
            <div className={`config-panel ${activeCategory ? 'config-panel--open' : ''}`}>
                {controls && (
                    <>
                        <div className="config-panel__header">
                            <h2 className="config-panel__title">
                                {activeCategory.toUpperCase()}
                            </h2>
                            <button
                                className="config-panel__close"
                                onClick={() => toggleCategory(activeCategory)}
                            >
                                &times;
                            </button>
                        </div>
                        {controls.map(ctrl => (
                            <div key={ctrl.key} className="config-control">
                                <label className="config-control__label">{ctrl.label}</label>
                                {ctrl.type === 'color' ? (
                                    <div className="config-control__color-wrapper">
                                        <div
                                            className="config-control__color-preview"
                                            style={{ backgroundColor: config[ctrl.key] }}
                                        />
                                        <input
                                            type="color"
                                            className="config-control__color-input"
                                            value={config[ctrl.key]}
                                            onChange={e => updateConfig(ctrl.key, e.target.value)}
                                        />
                                    </div>
                                ) : (
                                    <div className="config-control__range-wrapper">
                                        <input
                                            type="range"
                                            className="config-control__range"
                                            min={ctrl.min}
                                            max={ctrl.max}
                                            step={ctrl.step}
                                            value={config[ctrl.key]}
                                            onChange={e => updateConfig(ctrl.key, parseFloat(e.target.value))}
                                        />
                                        <span className="config-control__range-value">
                                            {config[ctrl.key].toFixed(2)}
                                        </span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </>
                )}
            </div>

            {/* Category bar */}
            <div className="category-bar">
                {CATEGORIES.map(cat => (
                    <button
                        key={cat.key}
                        className={`category-btn ${activeCategory === cat.key ? 'category-btn--active' : ''}`}
                        onClick={() => toggleCategory(cat.key)}
                    >
                        {cat.label}
                    </button>
                ))}
            </div>
        </div>
    )
}
